import React from 'react';
import { FormProject } from '../../form/compositions/FormProject';
import { FramedContent } from '../../framed-content';

const ProjectForm = (props: any) => {
  if (!props.flowData || !props.flowData?.itemData?.title || !props.flowData?.itemData?.description || props.flowData?.itemData?.description === '<p></p>') {
    props.setNextStepDisabled(true);
  } else {
    props.setNextStepDisabled(false);
  }
  return (
    <FramedContent>
      <FormProject
        formData={props.flowData}
        headline={'Ok, dann erzählen Sie doch etwas mehr...'}
        subtitle={'Folgende Frage können dabei hilfreich sein: Welches Ziel verfolgt es? Was sind die Schwerpunkte? An wen richtet sich Ihr Projekt?'}
        onChange={formData => {
          props.flowFunctions.setFlowData({ ...props.flowData, ...formData });
        }}
      />
    </FramedContent>
  );
};

export default ProjectForm;
